import React from 'react';
import PropTypes from 'prop-types';

function GeneralTextBox({ label, id, name, type, value, onChange, placeholder, required, disabled, multiline, rows }) {
  const handleInputChange = (e) => {
    let newValue = e.target.value;
    if (type === 'currency') {
      // Remove non-numeric characters except the dot
      newValue = newValue.replace(/[^\d.]/g, '');
      // Ensure there is only one dot
      if (newValue.split('.').length > 2) {
        newValue = newValue.slice(0, newValue.lastIndexOf('.'));
      }
    }
    onChange({
      target: {
        name: e.target.name,
        value: newValue,
      },
    });
  };

  return (
    <div className="mb-4">
      <label htmlFor={id} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label>
      <div className="relative">
        {multiline ? (
          <textarea
            id={id}
            name={name}
            value={value}
            onChange={handleInputChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            rows={rows}
          />
        ) : (
          <input
            type={type === 'currency' ? 'text' : type}
            id={id}
            name={name}
            value={value}
            onChange={handleInputChange}
            className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ${type === 'currency' ? 'pl-8' : 'p-2.5'} dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
}

GeneralTextBox.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'number', 'password', 'email', 'currency']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
};

GeneralTextBox.defaultProps = {
  type: 'text', // Default type is 'text'
  placeholder: '',
  required: false,
  disabled: false,
  multiline: false,
  rows: 3,
};

export default GeneralTextBox;
